import $ from 'jquery';

// in case we got "radio" buttons, this piece of js allows
// unchecking of an activated radio button. Every other
// behaviour is done in CSS.
$('.accordion--radio .accordion__header').on('click', function (ev) {
    const $parent = $(this).closest('.accordion__element');
    const $check = $parent.find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
        ev.preventDefault();
    }
});
